<template>
    <div>

        <div style="margin-bottom: 20px;">
            <el-upload :data="{collection_id:collection_id}"  ref="pltihuan" :auto-upload="false"  class="upload-demo" action="https://interface.luchuaner.com/piliangtihuan"
                :show-file-list="false" :on-change="handleChange" :on-preview="handlePreview"
                :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" multiple accept="image/*">
                <el-button slot="trigger" v-if="yuantulist.length==0" size="small" type="primary">选择图片</el-button>
                <span v-if="yuantulist.length==0" style="font-size: 12px;color:#bbbbbb;margin-left: 10px;">注：根据文件名匹配结果</span>
               
            </el-upload>
            <el-button :loading="loading" v-if="yuantulist.length > 0" size="small" type="primary" @click="submitUpload">开始替换</el-button>
                <el-button v-if="yuantulist.length > 0" size="small" type="" @click="cxxz">重新选择</el-button>
           
           
        </div>
        <div style="display: flex;justify-content: space-between;" v-if="filelist.length > 0">
            <div style="width:45%;display:flex;flex-direction: column;align-items: center;justify-content: center;">
                <div style="margin-bottom: 20px;">原图</div>
                <div v-for="(item, index) in yuantulist" :key="index" style="margin-bottom: 20px;display: flex;flex-direction: column;align-items: center;">
                    <div style="width:200px;height: 200px;border:1px solid #cccccc;">
                        <img :src="item['600_path']" style="width:200px;height: 200px;object-fit: contain;" />                        
                    </div>
                    <div style="font-size: 12px;margin-top:10px;">
                            {{ item.old_file_name }}
                        </div>
                </div>

            </div>
            <div style="width:45%;display:flex;flex-direction: column;align-items: center;justify-content: center;">
                <div style="margin-bottom: 20px;">替换为</div>
                <div v-for="(item, index) in filelist" :key="index" style="margin-bottom: 20px;display: flex;flex-direction: column;align-items: center;">
                    <div style="width:200px;height: 200px;border:1px solid #cccccc;">
                        <img :src="item.image_url" style="width:200px;height: 200px;object-fit: contain;" />
                    </div>
                    <div style="font-size: 12px;margin-top:10px;">
                        {{ item.name }}
                    </div>
                </div>
            </div>
        </div>
        <div>

        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            filelist: [],
            yuantulist: [],
            isover:0,
            loading:false
        }
    },
    props: {
        allphotos: Array,
        collection_id:Number
    },
    methods: {
        submitUpload() {
            this.loading = true
        this.$refs.pltihuan.submit();
      },
        cxxz(){
          this.filelist.length = 0
          this.yuantulist=new Array()
        },
        handleChange(file, fileList) {
            this.filelist = fileList
            this.filelist.forEach((ele, index) => {
                ele.image_url = URL.createObjectURL(ele.raw);
                let yuantuarr = this.allphotos.filter(ele2 => {
                    return ele2.old_file_name == ele.name
                })
                if (yuantuarr.length > 0) {
                    yuantuarr.forEach(ele3 => {
                        this.yuantulist.push(ele3)
                    })
                } else {
                    this.filelist.splice(index, 1);
                }
                //console.log(yuantuobj)
                // if(yuantuobj){
                //     
                // }
            })
            let set = new Set(this.yuantulist)
            this.yuantulist = Array.from(set)
            console.log(this.yuantulist)
            if(this.yuantulist.length==0){
                this.$notify.error({
                    title: '批量替换',
                    message: '未找到匹配图片'
                });
             
            }

        },
        handlePreview() {

        },
        handleAvatarSuccess() {
            this.isover = this.isover+1
            if(this.isover==this.filelist.length){
                this.$notify.success({
                    title: '批量替换',
                    message: '替换完成'
                });
                setTimeout(() => {
                    window.location.reload()
                }, 1000);
            }
        },
        beforeAvatarUpload() {
             
        }

    }
}
</script>

<style></style>